

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * H5与native协议 js文件
 */
(function (win, $, UpSDK) {
    var apiStatus = {};
    var iframe = null;
    var appInfo = window.__app_info || {};
    var urlPrefixCallAppInAndroid = appInfo.urlPrefixCallAppInAndroid || 'uplivecn://goWindow'; // android调用外部协议
    var urlPrefixCallAppInIos = appInfo.urlPrefixCallAppInIos || 'https://ios.upliveapps.com/goWindow';

    // if (window.isUpVoice || window.__app_feature === 'haya') { // 声播协议
    //     urlPrefixCallAppInIos = 'https://voice.upliveapps.com/goWindow'; // ios调用外部协议
    // } else {
    //     urlPrefixCallAppInIos = 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议
    // }
    //
    // let isBubbly = false;
    //
    // if(window.feature == 777 || window.feature === 'bubbly' || window.__app_feature === 'bubbly' || window.location.href.indexOf('feature=777') !== -1) {
    //     isBubbly = true;
    //     urlPrefixCallAppInIos = 'https://ios.bubbly.live/goWindow'; // ios调用外部协议
    //     urlPrefixCallAppInAndroid = 'bubblycn://goWindow'; // android调用外部协议
    // }

    var native = {
        send: function send(url) {
            if (appInfo.normalScheme && appInfo.normalScheme !== 'uplive') {
                url = url.replace('uplive://', appInfo.normalScheme + '://');
            }
            if (iframe) {
                document.body.removeChild(iframe);
                iframe = null;
            }
            if (!iframe) {
                iframe = document.createElement('iframe');
                iframe.id = 'up_callapp_iframe_' + Date.now();
                iframe.frameborder = '0';
                iframe.style.cssText = 'display:none;border:0;width:0;height:0;';
                document.body.appendChild(iframe);
            }
            iframe.src = url;
        },

        // 根据不同的包，判断一下URl
        checkUrl: function checkUrl(url) {
            if (appInfo.normalScheme && appInfo.normalScheme !== 'uplive') {
                url = url.replace('uplive://', appInfo.normalScheme + '://');
            }
            return url;
        },

        //解决声播跟uplive公用项目的问题
        changeVoiceDeeplink: function changeVoiceDeeplink() {
            if (window.isUpVoice) {
                // 声播协议
                urlPrefixCallAppInIos = 'https://voice.upliveapps.com/goWindow'; // ios调用外部协议
            } else {
                urlPrefixCallAppInIos = appInfo.urlPrefixCallAppInIos || 'https://ios.upliveapps.com/goWindow'; // ios调用外部协议
            }
        },
        sendUriScheme: function sendUriScheme(url) {
            var feature = this.query('feature') || 0;
            var system = this.getSystem();
            if (system == 'ios') {
                if (feature) {
                    url = this.addParam(url, { feature: feature });
                }
            }
            window.location.href = url;
        },
        query: function query(name, scope) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
                scope = scope || 'search',
                r = location[scope].substr(1).match(reg);
            if (r != null) {
                return unescape(r[2]);
            }
            return null;
        },


        addParam: function addParam(url, data) {
            if (typeof data === 'undefined') {
                return;
            }

            var hashReg = /#.*$/gi,
                hashMatch = url.match(hashReg),
                hash = '';

            if (hashMatch) {
                hash = hashMatch[0];
            }

            // 去除hash值的url
            var preUrl = url.replace(hash, '');

            var searchReg = /\?(.*?)$/gi;
            var result = searchReg.exec(preUrl);
            var query;
            if (result) {
                query = result[1].split('#')[0];
            }

            var id = !query ? '' : '&';

            return preUrl + (query && query.length > 0 ? '' : '?') + (id + $.param(data)) + hash;
        },
        // 获得平台类型
        // weixin, weibo, qq, uplive，海外版本Android在URL Hash中添加标识 #pl=uplive
        getPlatform: function getPlatform() {
            var _ref = [navigator.userAgent, 'other'],
                ua = _ref[0],
                pl = _ref[1];


            if (ua.match(/uplive/i) || this.query('pl', 'hash') == 'uplive' || localStorage.getItem('__inuplive__') || this.query('pl') == 'uplive') {
                pl = 'uplive';
            } else if (ua.match(/micromessenger/i)) {
                pl = 'wechat';
            } else if (ua.match(/qq\//i)) {
                pl = 'qq';
            } else if (ua.match(/weibo/i)) {
                pl = 'weibo';
            } else if (ua.match(/renren/i)) {
                pl = 'renren';
            } else if (ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1) {
                pl = 'fb';
            } else if (ua.match(/Line/i)) {
                pl = 'line';
            } else if (ua.match(/[Tt]witter/i)) {
                // twitter
                pl = 'twitter';
            } else if (ua.match(/KAKAOTALK/i)) {
                pl = 'kakao';
            } else if (ua.match(/Instagram/i)) {
                pl = 'instagram';
            } else if (ua.match(/Messenger/i)) {
                pl = 'messenger';
            }

            return pl;
        },


        // 获得当前系统类型
        getSystem: function getSystem() {
            var ua = navigator.userAgent;
            return (/(iPhone|iPad|iPod|iOS)/i.test(ua) ? 'ios' : /[aA]ndroid/i.test(ua) ? 'android' : 'pc'
            );
        },


        // 系统语言
        getLanguage: function getLanguage() {
            var language = navigator.language || navigator.browserLanguage;

            if (language) {
                var arr = language.split('-');
                arr[1] = arr[1].toUpperCase();
                language = arr.join('-');
            }

            return language;
        },


        // 检查api是否可用
        checkAvail: function checkAvail() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                apiname = _ref2.apiname,
                errtip = _ref2.errtip;

            setTimeout(function () {
                if (!apiStatus[apiname] && errtip) {
                    if (typeof errtip == 'function') {
                        errtip();
                    } else {
                        alert(errtip);
                    }
                }
            }, 3000);
        },

        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getConfigs: function getConfigs() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref3$complete = _ref3.complete,
                complete = _ref3$complete === undefined ? function () {} : _ref3$complete,
                _ref3$invalid = _ref3.invalid,
                invalid = _ref3$invalid === undefined ? 0 : _ref3$invalid,
                _ref3$errtip = _ref3.errtip,
                errtip = _ref3$errtip === undefined ? '不支持' : _ref3$errtip;

            var self = this;
            var url = 'uplive://getConfigs?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getConfigs']",
                jsCallback: '$.getConfigsComplete'
            };

            $.getConfigsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getConfigs',
                errtip: errtip
            });
        },


        /**
         * 获取配置信息
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getUserInfo: function getUserInfo() {
            var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref4$complete = _ref4.complete,
                complete = _ref4$complete === undefined ? function () {} : _ref4$complete,
                _ref4$invalid = _ref4.invalid,
                invalid = _ref4$invalid === undefined ? 0 : _ref4$invalid,
                _ref4$errtip = _ref4.errtip,
                errtip = _ref4$errtip === undefined ? '不支持' : _ref4$errtip;

            var self = this;
            var url = 'uplive://getUserInfo?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getUserInfo']",
                jsCallback: '$.getUserInfoComplete'
            };

            $.getUserInfoComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getUserInfo',
                errtip: errtip
            });
        },


        /**
         * 获取主播信息
         * @param cfg {
         *      complete: function(){}
         * }
         *
         */
        getHostInfo: function getHostInfo() {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref5$complete = _ref5.complete,
                complete = _ref5$complete === undefined ? function () {} : _ref5$complete,
                _ref5$errtip = _ref5.errtip,
                errtip = _ref5$errtip === undefined ? '不支持' : _ref5$errtip;

            var self = this;
            var url = 'uplive://getHostInfo?json=';
            var params = {
                receive: "$['upliveapp_getHostInfo']",
                jsCallback: '$.getHostInfoComplete'
            };

            $.getHostInfoComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getHostInfo',
                errtip: errtip
            });
        },


        // 上报提现结果给客户端
        acceptAgreement: function acceptAgreement() {
            var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref6$errtip = _ref6.errtip,
                errtip = _ref6$errtip === undefined ? '不支持' : _ref6$errtip;

            var url = 'uplive://acceptAgreement?json=';
            var params = {
                receive: "$['upliveapp_acceptAgreement']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'acceptAgreement',
                errtip: errtip
            });
        },

        /**
         * 跳转个人主页
         * @param cfg {
         *      uid: 10234, // {Number} 整型
                tab: 0：动态 1：关注 2：粉丝 3：守护
         * }
         */
        profile: function profile() {
            var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref7$uid = _ref7.uid,
                uid = _ref7$uid === undefined ? 0 : _ref7$uid,
                _ref7$tab = _ref7.tab,
                tab = _ref7$tab === undefined ? 0 : _ref7$tab,
                _ref7$errtip = _ref7.errtip,
                errtip = _ref7$errtip === undefined ? '' : _ref7$errtip,
                _ref7$action = _ref7.action,
                action = _ref7$action === undefined ? 'callapp' : _ref7$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10),
                    tab: tab
                },
                receive: "$['upliveapp_profile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'profile',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转广场
         * @param publish = 0 | 1
         * @param errtip
         * @param action
         * @returns {string}
         */
        goFeedPlaza: function goFeedPlaza() {
            var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref8$publish = _ref8.publish,
                publish = _ref8$publish === undefined ? 0 : _ref8$publish,
                _ref8$errtip = _ref8.errtip,
                errtip = _ref8$errtip === undefined ? '' : _ref8$errtip,
                _ref8$action = _ref8.action,
                action = _ref8$action === undefined ? 'callapp' : _ref8$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goFeedPlaza',
                extend: {
                    publish: parseInt(publish, 2) || 0
                },
                receive: ''
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFeedPlaza',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到直播间
         * @param cfg {
         *      uid: 10234, // {Number} 整型
         *      roomid: 10234 {Number} 整型
         * }
         */
        goRoom: function goRoom() {
            var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref9$uid = _ref9.uid,
                uid = _ref9$uid === undefined ? 0 : _ref9$uid,
                _ref9$roomid = _ref9.roomid,
                roomid = _ref9$roomid === undefined ? 0 : _ref9$roomid,
                _ref9$errtip = _ref9.errtip,
                errtip = _ref9$errtip === undefined ? '' : _ref9$errtip,
                _ref9$action = _ref9.action,
                action = _ref9$action === undefined ? 'callapp' : _ref9$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                },
                receive: "$['upliveapp_goRoom']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRoom',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },
        goRank: function goRank() {
            var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref10$name = _ref10.name,
                name = _ref10$name === undefined ? 1 : _ref10$name,
                _ref10$errtip = _ref10.errtip,
                errtip = _ref10$errtip === undefined ? '' : _ref10$errtip,
                _ref10$action = _ref10.action,
                action = _ref10$action === undefined ? 'callapp' : _ref10$action;

            var url = 'uplive://goWindow?json=';
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }

            var params = {
                key: key,
                receive: "$['upliveapp_goRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goRank',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        // 跳转充值界面
        gopay: function gopay() {
            var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref11$errtip = _ref11.errtip,
                errtip = _ref11$errtip === undefined ? '' : _ref11$errtip,
                _ref11$complete = _ref11.complete,
                complete = _ref11$complete === undefined ? function () {} : _ref11$complete,
                _ref11$action = _ref11.action,
                action = _ref11$action === undefined ? 'callapp' : _ref11$action,
                _ref11$param = _ref11.param,
                param = _ref11$param === undefined ? {} : _ref11$param;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = _extends({
                key: 'pay',
                receive: "$['upliveapp_gopay']",
                jsCallback: "$['getGopayComplete']"
            }, param);

            $.getGopayComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'gopay',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        //跳转到尊贵会员页
        goLeagueDetail: function goLeagueDetail() {
            var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref12$errtip = _ref12.errtip,
                errtip = _ref12$errtip === undefined ? '' : _ref12$errtip,
                _ref12$complete = _ref12.complete,
                complete = _ref12$complete === undefined ? function () {} : _ref12$complete,
                _ref12$action = _ref12.action,
                action = _ref12$action === undefined ? 'callapp' : _ref12$action;

            var self = this;
            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'leagueDetail',
                receive: "$['upliveapp_goLeagueDetail']",
                jsCallback: "$['goLeagueDetailComplete']"
            };

            $.goLeagueDetailComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goLeagueDetail',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        // 上报提现结果给客户端
        reportCashResult: function reportCashResult() {
            var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref13$success = _ref13.success,
                success = _ref13$success === undefined ? 1 : _ref13$success,
                errtip = _ref13.errtip;

            var url = 'uplive://h5cash?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportCashResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportCashResult',
                errtip: errtip
            });
        },


        // 上报充值结果给客户端
        reportPayResult: function reportPayResult() {
            var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref14$success = _ref14.success,
                success = _ref14$success === undefined ? 1 : _ref14$success,
                errtip = _ref14.errtip;

            var url = 'uplive://h5payment?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_reportPayResult']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'reportPayResult',
                errtip: errtip
            });
        },


        // 关闭webview
        closeWindow: function closeWindow() {
            var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref15$errtip = _ref15.errtip,
                errtip = _ref15$errtip === undefined ? '' : _ref15$errtip;

            var url = 'uplive://closeWindow?json=';
            var params = {
                receive: "$['upliveapp_closeWindow']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'closeWindow',
                errtip: errtip
            });
        },


        // 浏览器中打开
        openBrowser: function openBrowser() {
            var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref16$url = _ref16.url,
                url = _ref16$url === undefined ? '' : _ref16$url,
                _ref16$errtip = _ref16.errtip,
                errtip = _ref16$errtip === undefined ? '' : _ref16$errtip,
                _ref16$action = _ref16.action,
                action = _ref16$action === undefined ? 'callapp' : _ref16$action;

            var _url = 'uplive://openBrowser?json=';
            var params = {
                receive: "$['upliveapp_openBrowser']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openBrowser',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(_url);
            }
        },

        // 打开新的webview
        openWebView: function openWebView() {
            var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref17$url = _ref17.url,
                url = _ref17$url === undefined ? '' : _ref17$url,
                _ref17$errtip = _ref17.errtip,
                errtip = _ref17$errtip === undefined ? '' : _ref17$errtip,
                _ref17$action = _ref17.action,
                action = _ref17$action === undefined ? 'callapp' : _ref17$action;

            var _url = 'uplive://openWebView?json=';
            var params = {
                receive: "$['upliveapp_openWebView']",
                url: url
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'openWebView',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(_url);
            }
        },


        // 获取地理位置
        getLocation: function getLocation() {
            var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref18$complete = _ref18.complete,
                complete = _ref18$complete === undefined ? function () {} : _ref18$complete,
                _ref18$errtip = _ref18.errtip,
                errtip = _ref18$errtip === undefined ? '不支持' : _ref18$errtip;

            var self = this;
            var url = 'uplive://getLocation?json=';
            var params = {
                receive: "$['upliveapp_getLocation']",
                jsCallback: '$.getLocationComplete'
            };

            $.getLocationComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getLocation',
                errtip: errtip
            });
        },

        /**
         * 支付调用
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        pay: function pay() {
            var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref19$complete = _ref19.complete,
                complete = _ref19$complete === undefined ? function () {} : _ref19$complete,
                _ref19$platform = _ref19.platform,
                platform = _ref19$platform === undefined ? 'wxpay' : _ref19$platform,
                _ref19$productId = _ref19.productId,
                productId = _ref19$productId === undefined ? '' : _ref19$productId,
                _ref19$errtip = _ref19.errtip,
                errtip = _ref19$errtip === undefined ? '不支持支付' : _ref19$errtip;

            var self = this;
            var _url = 'uplive://payment?json=';
            var _params = {
                receive: "$['upliveapp_pay']",
                platform: platform || 'wxpay',
                params: {
                    productId: productId
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },

        /**
         * 支付调用,充值U钻最小档
         * @param data {object}
         *      - platform 支付平台
         *      - complete {function}
         *      - params 参数
         * @return this
         */
        rechargeMin: function rechargeMin() {
            var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref20$complete = _ref20.complete,
                complete = _ref20$complete === undefined ? function () {} : _ref20$complete,
                _ref20$errtip = _ref20.errtip,
                errtip = _ref20$errtip === undefined ? '不支持支付' : _ref20$errtip;

            var self = this;
            var _url = 'uplive://rechargeMin?json=';
            var _params = {
                receive: "$['upliveapp_rechargeMin']",
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'pay',
                errtip: errtip
            });
        },
        ynpay: function ynpay() {
            var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref21$complete = _ref21.complete,
                complete = _ref21$complete === undefined ? function () {} : _ref21$complete,
                _ref21$platform = _ref21.platform,
                platform = _ref21$platform === undefined ? 'wxpay' : _ref21$platform,
                _ref21$productId = _ref21.productId,
                productId = _ref21$productId === undefined ? '' : _ref21$productId,
                _ref21$orderStr = _ref21.orderStr,
                orderStr = _ref21$orderStr === undefined ? '' : _ref21$orderStr,
                _ref21$orderId = _ref21.orderId,
                orderId = _ref21$orderId === undefined ? '' : _ref21$orderId,
                _ref21$errtip = _ref21.errtip,
                errtip = _ref21$errtip === undefined ? '不支持支付' : _ref21$errtip;

            var self = this;
            var _url = 'uplive://ynzf?json=';
            var _params = {
                receive: "$['upliveapp_ynpay']",
                platform: platform || 'wxpay',
                params: {
                    orderId: orderId + '',
                    productId: productId + '',
                    orderStr: orderStr
                },
                jsCallback: '$.payComplete'
            };

            $.payComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'ynpay',
                errtip: errtip
            });
        },
        checkRepairOrder: function checkRepairOrder() {
            var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref22$complete = _ref22.complete,
                complete = _ref22$complete === undefined ? function () {} : _ref22$complete,
                _ref22$errtip = _ref22.errtip,
                errtip = _ref22$errtip === undefined ? '' : _ref22$errtip;

            var self = this;
            var url = 'uplive://checkRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_checkRepairOrder']",
                jsCallback: '$.checkRepairOrderComplete'
            };

            $.checkRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'checkRepairOrder',
                errtip: errtip
            });
        },
        goRepairOrder: function goRepairOrder() {
            var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref23$complete = _ref23.complete,
                complete = _ref23$complete === undefined ? function () {} : _ref23$complete,
                _ref23$errtip = _ref23.errtip,
                errtip = _ref23$errtip === undefined ? '' : _ref23$errtip;

            var url = 'uplive://goRepairOrder?json=';
            var params = {
                receive: "$['upliveapp_goRepairOrder']",
                jsCallback: '$.goRepairOrderComplete'
            };

            $.goRepairOrderComplete = function (param) {
                // 支付
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goRepairOrder',
                errtip: errtip
            });
        },

        // 通过相机获取图片
        getPhotoCamera: function getPhotoCamera() {
            var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref24$complete = _ref24.complete,
                complete = _ref24$complete === undefined ? function () {} : _ref24$complete,
                _ref24$type = _ref24.type,
                type = _ref24$type === undefined ? "share" : _ref24$type,
                _ref24$crop = _ref24.crop,
                crop = _ref24$crop === undefined ? 0 : _ref24$crop,
                _ref24$width = _ref24.width,
                width = _ref24$width === undefined ? 640 : _ref24$width,
                _ref24$height = _ref24.height,
                height = _ref24$height === undefined ? 640 : _ref24$height,
                _ref24$errtip = _ref24.errtip,
                errtip = _ref24$errtip === undefined ? '不支持' : _ref24$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "camera", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoCamera']",
                jsCallback: '$.getPhotoCameraComplete'
            };

            $.getPhotoCameraComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoCamera',
                errtip: errtip
            });
        },

        // 通过图库获取图片
        getPhotoAlbum: function getPhotoAlbum() {
            var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref25$complete = _ref25.complete,
                complete = _ref25$complete === undefined ? function () {} : _ref25$complete,
                _ref25$type = _ref25.type,
                type = _ref25$type === undefined ? "share" : _ref25$type,
                _ref25$crop = _ref25.crop,
                crop = _ref25$crop === undefined ? 0 : _ref25$crop,
                _ref25$width = _ref25.width,
                width = _ref25$width === undefined ? 640 : _ref25$width,
                _ref25$height = _ref25.height,
                height = _ref25$height === undefined ? 640 : _ref25$height,
                _ref25$errtip = _ref25.errtip,
                errtip = _ref25$errtip === undefined ? '不支持' : _ref25$errtip;

            var self = this;
            var url = 'uplive://getPhoto?json=';
            var params = {
                type: type || 'share',
                sourceType: "album", //图片来源，照相机
                crop: crop,
                width: width,
                height: height,
                receive: "$['upliveapp_getPhotoAlbum']",
                jsCallback: '$.getPhotoAlbumComplete'
            };

            $.getPhotoAlbumComplete = function (param) {
                // "url":"网络链接"
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getPhotoAlbum',
                errtip: errtip
            });
        },


        // 客户端分享
        share: function share() {
            var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref26$complete = _ref26.complete,
                complete = _ref26$complete === undefined ? function () {} : _ref26$complete,
                _ref26$title = _ref26.title,
                title = _ref26$title === undefined ? '分享标题' : _ref26$title,
                _ref26$url = _ref26.url,
                url = _ref26$url === undefined ? 'http://www.baidu.com' : _ref26$url,
                _ref26$imageUrl = _ref26.imageUrl,
                imageUrl = _ref26$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref26$imageUrl,
                _ref26$desc = _ref26.desc,
                desc = _ref26$desc === undefined ? '分享表述' : _ref26$desc,
                _ref26$platform = _ref26.platform,
                platform = _ref26$platform === undefined ? {} : _ref26$platform,
                _ref26$from = _ref26.from,
                from = _ref26$from === undefined ? '' : _ref26$from,
                _ref26$errtip = _ref26.errtip,
                errtip = _ref26$errtip === undefined ? '客户端不支持分享' : _ref26$errtip;

            var self = this;
            var _url = 'uplive://sharePage?json=';
            var pls = ['qq', 'qzone', 'wechat_friends', 'wechat_circle', 'sina', 'fb', 'tw'];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            var params = {
                receive: "$['upliveapp_share']",
                platform: {},
                from: from,
                jsCallback: '$.upliveShareComplete'
            };

            pls.forEach(function (item, i) {
                params.platform[item] = {
                    url: url,
                    title: title,
                    imageUrl: imageUrl,
                    desc: desc
                };
            });

            if (JSON.stringify(platform) != '{}') {
                params = $.extend(true, params, {
                    platform: platform
                });
            }

            for (var i in params) {
                if (i == 'platform') {
                    for (var j in params[i]) {
                        for (var k in params[i][j]) {
                            if (k == 'title' || k == 'desc') {
                                params[i][j][k] = encodeURIComponent(params[i][j][k]);
                            }
                            if (k == 'url' && params[i][j][k] && oauthtype[j]) {
                                var _url2 = params[i][j][k];

                                params[i][j][k] = this.addParam(_url2, {
                                    oauthtype: oauthtype[j]
                                });
                            }
                        }
                    }
                }
            }

            $.upliveShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(_url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'share',
                errtip: errtip
            });
        },


        // 单渠道分享
        singleShare: function singleShare() {
            var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref27$complete = _ref27.complete,
                complete = _ref27$complete === undefined ? function () {} : _ref27$complete,
                _ref27$title = _ref27.title,
                title = _ref27$title === undefined ? '分享标题' : _ref27$title,
                _ref27$url = _ref27.url,
                url = _ref27$url === undefined ? 'http://www.baidu.com' : _ref27$url,
                _ref27$imageUrl = _ref27.imageUrl,
                imageUrl = _ref27$imageUrl === undefined ? 'https://m.baidu.com/static/index/plus/plus_logo.png' : _ref27$imageUrl,
                _ref27$desc = _ref27.desc,
                desc = _ref27$desc === undefined ? '分享表述' : _ref27$desc,
                _ref27$type = _ref27.type,
                type = _ref27$type === undefined ? 'fb' : _ref27$type,
                _ref27$errtip = _ref27.errtip,
                errtip = _ref27$errtip === undefined ? '客户端不支持分享' : _ref27$errtip,
                _ref27$action = _ref27.action,
                action = _ref27$action === undefined ? 'callapp' : _ref27$action;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://singleShare?json=';
            var pls = ["qq", "qzone", "wechat_friends", "wechat_circle", "sina", "fb", "tw", "messenger", "whatsapp", "ins", "line", "kakao"];
            var oauthtype = { 'fb': 'fb', 'tw': 'twitter', 'sina': 'weibo' };

            if (url && oauthtype[type]) {
                url = this.addParam(url, {
                    oauthtype: oauthtype[type]
                });
            }
            if (type == 'sina') {
                desc += '>>' + url;
            }
            var params = {
                receive: "$['upliveapp_singleShare']",
                platform: {
                    url: url,
                    title: system == 'ios' ? title : encodeURIComponent(title),
                    imageUrl: imageUrl,
                    desc: system == 'ios' ? desc : encodeURIComponent(desc)
                },
                type: type,
                jsCallback: '$.upliveSingleShareComplete'
            };

            $.upliveSingleShareComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            _url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(_url);
                this.checkAvail({
                    apiname: 'singleShare',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(_url);
            }
        },


        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByArea: function goHotListByArea() {
            var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref28$countryCode = _ref28.countryCode,
                countryCode = _ref28$countryCode === undefined ? '' : _ref28$countryCode,
                _ref28$errtip = _ref28.errtip,
                errtip = _ref28$errtip === undefined ? '' : _ref28$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                },
                receive: "$['upliveapp_goHotListByArea']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goHotListByArea',
                errtip: errtip
            });
        },

        /*--------------------- V2.0.0 -------------------*/

        // 游客登录
        login: function login() {
            var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref29$complete = _ref29.complete,
                complete = _ref29$complete === undefined ? function () {} : _ref29$complete,
                _ref29$errtip = _ref29.errtip,
                errtip = _ref29$errtip === undefined ? '不支持登录' : _ref29$errtip;

            var self = this;
            var url = 'uplive://goLogin?json=';
            var params = {
                receive: "$['upliveapp_login']",
                jsCallback: '$.loginComplete'
            };
            $.loginComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'login',
                errtip: errtip
            });
        },


        // 刷新用户信息
        refreshProfile: function refreshProfile() {
            var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref30$errtip = _ref30.errtip,
                errtip = _ref30$errtip === undefined ? '不支持刷新用户信息' : _ref30$errtip;

            var url = 'uplive://refreshProfile?json=';
            var params = {
                receive: "$['upliveapp_refreshProfile']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'refreshProfile',
                errtip: errtip
            });
        },


        /* -------------------- ios 我的收益 --------------------- */

        goCashRecord: function goCashRecord() {
            var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref31$errtip = _ref31.errtip,
                errtip = _ref31$errtip === undefined ? '不支持领取纪录' : _ref31$errtip;

            var url = 'uplive://goCashRecord?json=';
            var params = {
                receive: "$['upliveapp_goCashRecord']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goCashRecord',
                errtip: errtip
            });
        },
        bindMobilePhone: function bindMobilePhone() {
            var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref32$complete = _ref32.complete,
                complete = _ref32$complete === undefined ? function () {} : _ref32$complete,
                _ref32$errtip = _ref32.errtip,
                errtip = _ref32$errtip === undefined ? '不支持手机绑定' : _ref32$errtip;

            var self = this;
            var url = 'uplive://bindMobilePhone?json=';
            var params = {
                receive: "$['upliveapp_bindMobilePhone']",
                jsCallback: '$.bindMobilePhoneComplete'
            };
            $.bindMobilePhoneComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindMobilePhone',
                errtip: errtip
            });
        },
        bindWechat: function bindWechat() {
            var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref33$complete = _ref33.complete,
                complete = _ref33$complete === undefined ? function () {} : _ref33$complete,
                _ref33$errtip = _ref33.errtip,
                errtip = _ref33$errtip === undefined ? '不支持微信绑定' : _ref33$errtip;

            var self = this;
            var url = 'uplive://bindWechat?json=';
            var params = {
                receive: "$['upliveapp_bindWechat']",
                jsCallback: '$.bindWechatComplete'
            };
            $.bindWechatComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'bindWechat',
                errtip: errtip
            });
        },
        setTitle: function setTitle() {
            var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref34$title = _ref34.title,
                title = _ref34$title === undefined ? '' : _ref34$title,
                _ref34$errtip = _ref34.errtip,
                errtip = _ref34$errtip === undefined ? function () {} : _ref34$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setTitle?json=';
            var _params = {
                receive: "$['upliveapp_setTitle']",
                params: {
                    title: title
                }
            };

            if (system == 'android') {
                document.title = title;
            } else {
                this.send(_url + JSON.stringify(_params));
                this.checkAvail({
                    apiname: 'setTitle',
                    errtip: errtip
                });
            }
        },


        /**
         * 设置客户端导航  点击icon支持回调函数,pagePath不去掉是为了兼容之前的其他项目
         */
        setNavBar: function setNavBar() {
            var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref35$backgroundColo = _ref35.backgroundColor,
                backgroundColor = _ref35$backgroundColo === undefined ? '#FFFFFF' : _ref35$backgroundColo,
                _ref35$skin = _ref35.skin,
                skin = _ref35$skin === undefined ? 0 : _ref35$skin,
                _ref35$iconPath = _ref35.iconPath,
                iconPath = _ref35$iconPath === undefined ? '' : _ref35$iconPath,
                _ref35$pagePath = _ref35.pagePath,
                pagePath = _ref35$pagePath === undefined ? '' : _ref35$pagePath,
                _ref35$iconPath2 = _ref35.iconPath1,
                iconPath1 = _ref35$iconPath2 === undefined ? '' : _ref35$iconPath2,
                _ref35$pagePath2 = _ref35.pagePath1,
                pagePath1 = _ref35$pagePath2 === undefined ? '' : _ref35$pagePath2,
                _ref35$iconCallback = _ref35.iconCallback,
                iconCallback = _ref35$iconCallback === undefined ? null : _ref35$iconCallback,
                _ref35$errtip = _ref35.errtip,
                errtip = _ref35$errtip === undefined ? function () {} : _ref35$errtip;

            var self = this;
            var system = this.getSystem();
            var _url = 'uplive://setNavBar?json=';
            var _params = {
                receive: "$['upliveapp_setNavBar']",
                params: {
                    backgroundColor: backgroundColor, // 十六进制
                    skin: skin, // 0: 默认紫色back + 黑色文本；1: 白色back + 白色文本
                    iconPath: iconPath, // 图片路径
                    pagePath: pagePath, // 点击icon的页面路径,
                    iconPath1: iconPath1,
                    pagePath1: pagePath1
                }
            };
            if (iconCallback && typeof iconCallback === 'function') {
                _params['jsCallback'] = "$.setNavBarComplete";

                $.setNavBarComplete = function () {
                    iconCallback.call(self);
                };
            }

            this.send(_url + JSON.stringify(_params));
            this.checkAvail({
                apiname: 'setNavBar',
                errtip: errtip
            });
        },

        /* ----------------------V 2.6.0 -------------------*/
        /**
         * 跳转到开播准备页面
         * @param autoplay: 是否自动开播, true=>自动开播, false=>不自动开播 默认false //该字段5.4.0之后才支持
         */
        goReadyToLive: function goReadyToLive() {
            var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref36$errtip = _ref36.errtip,
                errtip = _ref36$errtip === undefined ? '' : _ref36$errtip,
                _ref36$autoplay = _ref36.autoplay,
                autoplay = _ref36$autoplay === undefined ? false : _ref36$autoplay,
                _ref36$action = _ref36.action,
                action = _ref36$action === undefined ? 'callapp' : _ref36$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToLive',
                receive: "$['upliveapp_goReadyToLive']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToLive',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /* ----------------------V 7.6.0 -------------------*/
        /**
         * 跳转到avatar开播页面
         */
        goReadyToAvatarLive: function goReadyToAvatarLive() {
            var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref37$errtip = _ref37.errtip,
                errtip = _ref37$errtip === undefined ? '' : _ref37$errtip,
                _ref37$action = _ref37.action,
                action = _ref37$action === undefined ? 'callapp' : _ref37$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToAvatarLive',
                receive: "$['upliveapp_goReadyToAvatarLive']"
            };
            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToAvatarLive',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },
        /**
         * 跳转到我的背包页面
         * @param cfg {
         * }
         */
        goPack: function goPack() {
            var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref38$errtip = _ref38.errtip,
                errtip = _ref38$errtip === undefined ? '' : _ref38$errtip,
                _ref38$action = _ref38.action,
                action = _ref38$action === undefined ? 'callapp' : _ref38$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'pack',
                receive: "$['upliveapp_goPack']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPack',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到发现列表
         * @param cfg {
         * }
         */
        goFindList: function goFindList() {
            var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref39$errtip = _ref39.errtip,
                errtip = _ref39$errtip === undefined ? '' : _ref39$errtip,
                _ref39$action = _ref39.action,
                action = _ref39$action === undefined ? 'callapp' : _ref39$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'findList',
                receive: "$['upliveapp_goFindList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFindList',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到热门列表
         * @param cfg {
         * }
         */
        goHotList: function goHotList() {
            var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref40$errtip = _ref40.errtip,
                errtip = _ref40$errtip === undefined ? '' : _ref40$errtip,
                _ref40$action = _ref40.action,
                action = _ref40$action === undefined ? 'callapp' : _ref40$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'hotList',
                receive: "$['upliveapp_goHotList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goHotList',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到VIP特权页面
         * @param cfg {
         * }
         */
        goVipPrivileges: function goVipPrivileges() {
            var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref41$errtip = _ref41.errtip,
                errtip = _ref41$errtip === undefined ? '' : _ref41$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivileges',
                receive: "$['upliveapp_goVipPrivileges']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goVipPrivileges',
                errtip: errtip
            });
        },


        /**
         * 跳转到VIP特权设置页面
         * @param cfg {
         * }
         */
        goVipPrivilegesSetting: function goVipPrivilegesSetting() {
            var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref42$errtip = _ref42.errtip,
                errtip = _ref42$errtip === undefined ? '' : _ref42$errtip,
                _ref42$action = _ref42.action,
                action = _ref42$action === undefined ? 'callapp' : _ref42$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'vipPrivilegesSetting',
                receive: "$['upliveapp_goVipPrivilegesSetting']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goVipPrivilegesSetting',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转开通守护
         * uid  主播id
         * roomId 直播间id
         * complete 回调方法
         */
        goOpenGuard: function goOpenGuard() {
            var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref43$uid = _ref43.uid,
                uid = _ref43$uid === undefined ? 0 : _ref43$uid,
                _ref43$roomId = _ref43.roomId,
                roomId = _ref43$roomId === undefined ? 0 : _ref43$roomId,
                _ref43$complete = _ref43.complete,
                complete = _ref43$complete === undefined ? function () {} : _ref43$complete,
                _ref43$errtip = _ref43.errtip,
                errtip = _ref43$errtip === undefined ? '' : _ref43$errtip,
                _ref43$action = _ref43.action,
                action = _ref43$action === undefined ? 'callapp' : _ref43$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openGuard',
                extend: {
                    uid: uid,
                    roomid: roomId
                },
                receive: "$['upliveapp_goOpenGuard']",
                "jsCallback": "$.buyOpenGuardComplete"
            };

            $.buyOpenGuardComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goOpenGuard',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         *
         * 跳转IM聊天
         * uid  主播id
         *
         */

        openChat: function openChat() {
            var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref44$uid = _ref44.uid,
                uid = _ref44$uid === undefined ? 10005 : _ref44$uid,
                _ref44$errtip = _ref44.errtip,
                errtip = _ref44$errtip === undefined ? '' : _ref44$errtip,
                _ref44$action = _ref44.action,
                action = _ref44$action === undefined ? 'callapp' : _ref44$action,
                _ref44$type = _ref44.type,
                type = _ref44$type === undefined ? '' : _ref44$type;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openChat',
                extend: {
                    uid: +uid,
                    type: type
                },
                receive: "$['upliveapp_openChat']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'openChat',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到关注列表
         * @param cfg {
         * }
         */
        goFollowList: function goFollowList() {
            var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref45$errtip = _ref45.errtip,
                errtip = _ref45$errtip === undefined ? '' : _ref45$errtip,
                _ref45$action = _ref45.action,
                action = _ref45$action === undefined ? 'callapp' : _ref45$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'followList',
                receive: "$['upliveapp_goFollowList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFollowList',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到短视频录制准备页面；
         * @param cfg {
                topic: 话题,
                topicId: 话题id {int}
         * }
         */
        goReadyToShortVideo: function goReadyToShortVideo() {
            var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref46$topic = _ref46.topic,
                topic = _ref46$topic === undefined ? '' : _ref46$topic,
                _ref46$topicId = _ref46.topicId,
                topicId = _ref46$topicId === undefined ? '' : _ref46$topicId,
                _ref46$errtip = _ref46.errtip,
                errtip = _ref46$errtip === undefined ? '' : _ref46$errtip,
                _ref46$action = _ref46.action,
                action = _ref46$action === undefined ? 'callapp' : _ref46$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'readyToShortVideo',
                extend: {
                    topic: topic,
                    topicId: parseInt(topicId, 10)
                },
                receive: "$['upliveapp_goReadyToShortVideo']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goReadyToShortVideo',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到指定短视频页面&播放视频
         * @param cfg {
                rid: '主帖子ID', ［必须］
                dynamicId: '动态ID',［必须］
                dynamicType: "动态类型",［必须］
                // ［非必须］
                resourceUrls: {}, // 图片或者视频地址
                resourceDesp: "" // 资源描述信息
         * }
         */
        goDynamic: function goDynamic() {
            var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref47$rid = _ref47.rid,
                rid = _ref47$rid === undefined ? '' : _ref47$rid,
                _ref47$dynamicId = _ref47.dynamicId,
                dynamicId = _ref47$dynamicId === undefined ? '' : _ref47$dynamicId,
                _ref47$dynamicType = _ref47.dynamicType,
                dynamicType = _ref47$dynamicType === undefined ? '' : _ref47$dynamicType,
                _ref47$resourceUrls = _ref47.resourceUrls,
                resourceUrls = _ref47$resourceUrls === undefined ? null : _ref47$resourceUrls,
                _ref47$resourceDesp = _ref47.resourceDesp,
                resourceDesp = _ref47$resourceDesp === undefined ? '' : _ref47$resourceDesp,
                _ref47$errtip = _ref47.errtip,
                errtip = _ref47$errtip === undefined ? '' : _ref47$errtip;

            var url = 'uplive://goWindow?json=';
            var _params = {
                rid: rid,
                dynamicId: dynamicId,
                dynamicType: dynamicType
            };

            if (resourceUrls) {
                _params.resourceUrls = resourceUrls;
                _params.resourceDesp = resourceDesp;
            }
            var params = {
                key: 'dynamic',
                extend: _params,
                receive: "$['upliveapp_goDynamic']"
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'goDynamic',
                errtip: errtip
            });
        },


        /* ----------------------V ios 2.5.0 -------------------*/

        /**
         * 跳转到座驾商场 U钻购买
         * @param cfg {
         * }
         */
        goCarMall: function goCarMall() {
            var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref48$errtip = _ref48.errtip,
                errtip = _ref48$errtip === undefined ? '' : _ref48$errtip,
                _ref48$action = _ref48.action,
                action = _ref48$action === undefined ? 'callapp' : _ref48$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmall',
                receive: "$['upliveapp_goCarMall']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMall',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**
         * 会员订阅
         **/
        goSubscribeMembership: function goSubscribeMembership() {
            var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref49$errtip = _ref49.errtip,
                errtip = _ref49$errtip === undefined ? '' : _ref49$errtip,
                _ref49$action = _ref49.action,
                action = _ref49$action === undefined ? 'callapp' : _ref49$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'subscribeMembership',
                receive: "$['upliveapp_goSubscribeMembership']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goSubscribeMembership',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**
         * 账号绑定
         **/
        goBindAccount: function goBindAccount() {
            var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref50$errtip = _ref50.errtip,
                errtip = _ref50$errtip === undefined ? '' : _ref50$errtip,
                _ref50$action = _ref50.action,
                action = _ref50$action === undefined ? 'callapp' : _ref50$action,
                _ref50$complete = _ref50.complete,
                complete = _ref50$complete === undefined ? function () {} : _ref50$complete;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'bindAccount',
                receive: "$['upliveapp_goBindAccount']",
                jsCallback: "$.bindAccountComplete"
            };
            $.bindAccountComplete = function () {
                complete.call(self, JSON.parse(param));
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goBindAccount',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转到我的座驾
         * @param cfg {
         * }
         */
        goMyCar: function goMyCar() {
            var _ref51 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref51$errtip = _ref51.errtip,
                errtip = _ref51$errtip === undefined ? '' : _ref51$errtip,
                _ref51$action = _ref51.action,
                action = _ref51$action === undefined ? 'callapp' : _ref51$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'mycar',
                receive: "$['upliveapp_goMyCar']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goMyCar',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },
        setTelegramConfigs: function setTelegramConfigs() {
            var _ref52 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                botId = _ref52.botId,
                origin = _ref52.origin,
                _ref52$complete = _ref52.complete,
                complete = _ref52$complete === undefined ? function (e) {
                return e;
            } : _ref52$complete,
                _ref52$errtip = _ref52.errtip,
                errtip = _ref52$errtip === undefined ? function (e) {
                return e;
            } : _ref52$errtip;

            var url = 'uplive://setTelegramConfigs?json=';
            var authUrl = 'https://oauth.telegram.org/auth/get?';
            // https://oauth.telegram.org/auth/get?bot_id=1027864275&origin=https%3A%2F%2Fm.upliveapps.com&request_access=write
            authUrl += $.param({
                bot_id: botId,
                origin: 'https://' + origin,
                request_access: 'write'
            });
            var params = {
                authUrl: authUrl,
                receive: '$[\'upliveapp_setTelegramConfigs\']'
            };
            url += JSON.stringify(params);

            // 回调函数
            $['upliveapp_setTelegramConfigs'] = complete;

            this.send(url);
            this.checkAvail({
                apiname: 'setTelegramConfigs',
                errtip: errtip
            });
        },


        /*--------------------- 外部协议start -------------------*/
        // 打开链接
        openUrlCallApp: function openUrlCallApp() {
            var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref53$url = _ref53.url,
                url = _ref53$url === undefined ? '' : _ref53$url;

            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/webview?json=';
                ;
            }

            var params = {
                key: 'webview',
                url: url
            };
            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入app的资讯详情
        newDetailCallApp: function newDetailCallApp(detail) {
            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/newdetail?json=';
                ;
            }

            var params = _extends({
                key: 'newdetail'
            }, detail);

            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 外部打开app进入app的动态详情
        openDynamicCallApp: function openDynamicCallApp() {
            var _ref54 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref54$rid = _ref54.rid,
                rid = _ref54$rid === undefined ? 0 : _ref54$rid,
                _ref54$dynamicId = _ref54.dynamicId,
                dynamicId = _ref54$dynamicId === undefined ? 0 : _ref54$dynamicId,
                _ref54$dynamicType = _ref54.dynamicType,
                dynamicType = _ref54$dynamicType === undefined ? 1 : _ref54$dynamicType;

            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/openDynamic?json=';
            }

            var params = {
                key: 'openDynamic',
                extend: {
                    rid: rid,
                    dynamicId: dynamicId,
                    dynamicType: dynamicType
                }
            };

            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入用户主页
        profileCallApp: function profileCallApp() {
            var _ref55 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref55$uid = _ref55.uid,
                uid = _ref55$uid === undefined ? 0 : _ref55$uid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/profile?json=';
            }
            var params = {
                key: 'profile',
                extend: {
                    uid: parseInt(uid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 进入充值页
        goPayCallApp: function goPayCallApp() {
            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/pay?json=';
            }
            var params = {
                key: 'pay'
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 直播间
        goRoomCallApp: function goRoomCallApp() {
            var _ref56 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref56$uid = _ref56.uid,
                uid = _ref56$uid === undefined ? 0 : _ref56$uid,
                _ref56$roomid = _ref56.roomid,
                roomid = _ref56$roomid === undefined ? 0 : _ref56$roomid;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/room?json=';
            }
            var params = {
                key: 'room',
                extend: {
                    uid: parseInt(uid, 10),
                    roomid: parseInt(roomid, 10)
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 榜单页 1 星榜，2主播榜，3财富榜
        goRankCallApp: function goRankCallApp() {
            var _ref57 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref57$name = _ref57.name,
                name = _ref57$name === undefined ? 1 : _ref57$name;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/rank?json=';
            }
            var key = void 0;

            switch (parseInt(name, 10)) {
                case 1:
                    key = 'starank';
                    break;
                case 2:
                    key = 'hostrank';
                    break;
                case 3:
                    key = 'wealthrank';
                    break;
                default:
                    key = 'starank';
            }
            var params = {
                key: key
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        // 1.6.5 根据国家码跳转到国家主播列表
        goHotListByAreaCallApp: function goHotListByAreaCallApp() {
            var _ref58 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref58$countryCode = _ref58.countryCode,
                countryCode = _ref58$countryCode === undefined ? '' : _ref58$countryCode;

            var system = this.getSystem();
            var url = urlPrefixCallAppInIos + '?json=';

            if (system == 'android') {
                url = urlPrefixCallAppInAndroid + '/hotbyarea?json=';
            }
            var params = {
                key: 'hotbyarea',
                extend: {
                    countryCode: countryCode
                }
            };
            this.sendUriScheme(url + encodeURIComponent(JSON.stringify(params)));
        },


        //5.3.0 打开真爱团页面
        goTrueLoveCallApp: function goTrueLoveCallApp() {
            var system = this.getSystem();
            var _url = urlPrefixCallAppInIos + '?json=';

            var params = {
                key: 'goTrueLove'
            };

            if (system == 'android') {
                _url = urlPrefixCallAppInAndroid + '/goTrueLove?json=';
            }

            this.sendUriScheme(_url + encodeURIComponent(JSON.stringify(params)));
        },

        /*--------------------- 外部协议end -------------------*/

        /**
         * 发送GIFTO礼物
         * @param cfg {
         *      data {}；发送礼物的详细信息
         *      complete: function(){}
         * }
         *      uplive://sendGTOGift?json={
         *              "jsCallback": ""
         *              ,receive:""
         *              ,"data":"{
         *                  //接收礼物用户uid
         *                  "sendtoUid":"",
         *                  // 消息内容
         *                  "content": "1";
         *                  //礼物ID 必填
         *                  "giftId": "2";
         *                  //礼物名称
         *                  "giftName" : "3";
         *                  //连发系数
         *                  "giftAmount": "4";
         *                  //是否连续
         *                  "isContinuous": "5";
         *                  //连续次数 必填
         *                  "numContinuous": "6";
         *                  //礼物大图
         *                  "giftBigPicUrl": "6";
         *              }"}
         *
         */
        sendGTOGift: function sendGTOGift() {
            var _ref59 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref59$complete = _ref59.complete,
                complete = _ref59$complete === undefined ? function () {} : _ref59$complete,
                _ref59$data = _ref59.data,
                data = _ref59$data === undefined ? {} : _ref59$data,
                _ref59$errtip = _ref59.errtip,
                errtip = _ref59$errtip === undefined ? '不支持' : _ref59$errtip;

            var self = this;
            var url = 'uplive://sendGTOGift?json=';
            var params = {
                receive: "$['upliveapp_sendGTOGift']",
                jsCallback: '$.sendGiftoGiftComplete',
                data: data
            };

            $.sendGiftoGiftComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'sendGTOGift',
                errtip: errtip
            });
        },

        /**
         * 通过面板的id和礼物的id选中礼物
         * @param data
         * @param errtip
         */
        selectGift: function selectGift(_ref60) {
            var _ref60$data = _ref60.data,
                data = _ref60$data === undefined ? {} : _ref60$data,
                _ref60$errtip = _ref60.errtip,
                errtip = _ref60$errtip === undefined ? '不支持' : _ref60$errtip;

            var url = 'uplive://selectGift?json=';
            var params = {
                receive: "$['upliveapp_selectGift']",
                params: {
                    giftId: data.giftId,
                    labelId: data.labelId
                }
            };
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'selectGift',
                errtip: errtip
            });
        },

        /**
         * 发送登录结果
         * @param data
         * @param errtip
         */
        sendLoginResult: function sendLoginResult(_ref61) {
            var _ref61$data = _ref61.data,
                data = _ref61$data === undefined ? {} : _ref61$data,
                _ref61$errtip = _ref61.errtip,
                errtip = _ref61$errtip === undefined ? '不支持' : _ref61$errtip;

            var url = 'uplive://LoginResult?json=';
            var params = {
                receive: "$['upliveapp_loginResult']",
                userInfo: {
                    id: data.id,
                    first_name: data.first_name,
                    last_name: data.last_name,
                    username: data.username, // 首次注册这个值没有
                    photo_url: data.photo_url, // 首次注册这个值没有
                    auth_date: data.auth_date,
                    hash: data.hash,
                    extends: data.extends || ''
                },
                type: data.type || 'telegram',
                result: data.result,
                message: data.errmsg || '',
                jsCallback: '$.sendLoginResultCallback'
            };
            $.sendLoginResultCallback = function () {};
            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'loginResult',
                errtip: errtip
            });
        },

        /**---------------------------------3.3.1新增协议------------------------------------*/
        /**
         * 跳转荣耀挑战赛榜单
         * tab=0 今日上升榜  tab=1 赛季战力榜
         **/
        goPKRank: function goPKRank() {
            var _ref62 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref62$errtip = _ref62.errtip,
                errtip = _ref62$errtip === undefined ? '' : _ref62$errtip,
                _ref62$tab = _ref62.tab,
                tab = _ref62$tab === undefined ? 0 : _ref62$tab,
                _ref62$action = _ref62.action,
                action = _ref62$action === undefined ? 'callapp' : _ref62$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goPKRank',
                extend: {
                    tab: tab
                },
                receive: "$['upliveapp_goPKRank']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPKRank',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**
         * 跳转荣耀挑战赛
         **/
        goPKProfile: function goPKProfile() {
            var _ref63 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref63$errtip = _ref63.errtip,
                errtip = _ref63$errtip === undefined ? '' : _ref63$errtip,
                _ref63$action = _ref63.action,
                action = _ref63$action === undefined ? 'callapp' : _ref63$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goPKProfile',
                receive: "$['upliveapp_goPKProfile']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goPKProfile',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**
         * 跳转签到页面
         **/
        goCheckin: function goCheckin() {
            var _ref64 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref64$errtip = _ref64.errtip,
                errtip = _ref64$errtip === undefined ? '不支持' : _ref64$errtip,
                _ref64$action = _ref64.action,
                action = _ref64$action === undefined ? 'callapp' : _ref64$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'openCheckin',
                "receive": "$['upliveapp_goCheckin']"
                // "jsCallback":"$.goCheckinComplete"
            };
            // $.goCheckinComplete = function(param) { // usertoken: "", uid: "", language: ""
            //     complete.call(self, JSON.parse(param));
            // }

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCheckin',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /**
         * 跳转游戏列表
         **/
        goGameLivingList: function goGameLivingList() {
            var _ref65 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref65$errtip = _ref65.errtip,
                errtip = _ref65$errtip === undefined ? '' : _ref65$errtip,
                _ref65$action = _ref65.action,
                action = _ref65$action === undefined ? 'callapp' : _ref65$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: "goGameLivingList",
                receive: "$['upliveapp_goGameLivingList']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goGameLivingList',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**
         * 跳转游戏标签列表
         * labelId 标签id
         **/
        goGameLivingLabel: function goGameLivingLabel() {
            var _ref66 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref66$errtip = _ref66.errtip,
                errtip = _ref66$errtip === undefined ? '' : _ref66$errtip,
                _ref66$labelId = _ref66.labelId,
                labelId = _ref66$labelId === undefined ? 0 : _ref66$labelId,
                _ref66$action = _ref66.action,
                action = _ref66$action === undefined ? 'callapp' : _ref66$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: "goGameLivingLabel",
                extend: {
                    labelId: labelId
                },
                receive: "$['upliveapp_goGameLivingLabel']"
            };
            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goGameLivingLabel',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**---------------------------------3.8.0新增协议------------------------------------*/
        /** version 3.8.0
         * 跳转到座驾商场 U币购买
         * @param cfg {
         * }
         */
        goCarMallUseBill: function goCarMallUseBill() {
            var _ref67 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref67$errtip = _ref67.errtip,
                errtip = _ref67$errtip === undefined ? '' : _ref67$errtip,
                _ref67$action = _ref67.action,
                action = _ref67$action === undefined ? 'callapp' : _ref67$action,
                _ref67$complete = _ref67.complete,
                complete = _ref67$complete === undefined ? function () {} : _ref67$complete;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'carmallUseBill',
                receive: "$['upliveapp_goCarMallUseBill']",
                jsCallback: "$.goCarMallUseBillComplete"
            };
            $.goCarMallUseBillComplete = function (param) {
                complete.call(self, null);
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMallUseBill',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**---------------------------------4.2.0新增协议------------------------------------*/
        /** version 4.2.0
         *  动画预览
         * @param cfg {
         * }
         */
        previewAnimation: function previewAnimation() {
            var _ref68 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref68$errtip = _ref68.errtip,
                errtip = _ref68$errtip === undefined ? '' : _ref68$errtip,
                _ref68$action = _ref68.action,
                action = _ref68$action === undefined ? 'callapp' : _ref68$action,
                _ref68$type = _ref68.type,
                type = _ref68$type === undefined ? "car" : _ref68$type,
                productId = _ref68.productId,
                name = _ref68.name,
                _ref68$resources = _ref68.resources,
                resources = _ref68$resources === undefined ? [] : _ref68$resources;

            var url = 'uplive://previewAnimation?json=';
            var params = {
                key: 'previewanimation',
                receive: "$['upliveapp_previewAnimation']",
                data: {
                    productId: productId,
                    name: name,
                    type: type,
                    resources: resources
                }
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goCarMall',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**---------------------------------4.9.0新增协议------------------------------------*/
        /**
         * 跳转到我的家族页
         */
        goFamily: function goFamily() {
            var _ref69 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref69$errtip = _ref69.errtip,
                errtip = _ref69$errtip === undefined ? '' : _ref69$errtip,
                _ref69$action = _ref69.action,
                action = _ref69$action === undefined ? 'callapp' : _ref69$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goFamily',
                receive: "$['upliveapp_goFamily']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goFamily',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**---------------------------------5.2.5新增协议------------------------------------*/
        /**
         * 上报ins授权相关信息
         * code: ins返回的授权码
         * status: 授权状态 0成功 1取消 2失败
         * error_reason: 失败原因
         **/
        sendInstagramCode: function sendInstagramCode() {
            var _ref70 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref70$complete = _ref70.complete,
                complete = _ref70$complete === undefined ? function () {} : _ref70$complete,
                _ref70$code = _ref70.code,
                code = _ref70$code === undefined ? '' : _ref70$code,
                _ref70$status = _ref70.status,
                status = _ref70$status === undefined ? '' : _ref70$status,
                _ref70$error_reason = _ref70.error_reason,
                error_reason = _ref70$error_reason === undefined ? '' : _ref70$error_reason,
                _ref70$errtip = _ref70.errtip,
                errtip = _ref70$errtip === undefined ? '不支持' : _ref70$errtip;

            var self = this;
            var url = 'uplive://sendInstagramCode?json=';
            var params = {
                data: {
                    code: code,
                    status: status,
                    error_reason: error_reason
                },
                receive: "$['upliveapp_sendInstagramCode']",
                jsCallback: '$.sendInstagramCodeComplete'
            };

            $.sendInstagramCodeComplete = function (param) {
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'sendInstagramCode',
                errtip: errtip
            });
        },

        /**---------------------------------5.4.0新增协议------------------------------------*/
        /** version: 5.4.0
         * 跳转到热门直播间
         * @param  index 热门第n个直播间
         * @param  giftId 礼物id
         * @param  funcCode 道具功能Code  0:默认,1:悄悄话,2:全区广播,3:全部弹幕,4:普通弹幕,5:动画弹幕,6:器材弹幕,7:全部翻译,8:...
         */
        goHotLiveRoom: function goHotLiveRoom() {
            var _ref71 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref71$errtip = _ref71.errtip,
                errtip = _ref71$errtip === undefined ? '' : _ref71$errtip,
                _ref71$index = _ref71.index,
                index = _ref71$index === undefined ? 0 : _ref71$index,
                giftId = _ref71.giftId,
                funcCode = _ref71.funcCode,
                _ref71$action = _ref71.action,
                action = _ref71$action === undefined ? 'callapp' : _ref71$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'goHotLiveRoom',
                extend: {
                    index: index,
                    giftId: giftId,
                    funcCode: funcCode
                },
                receive: "$['upliveapp_goHotLiveRoom']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goHotLiveRoom',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /** version: 5.4.0
         * 更新U豆
         * @param cfg {
         *      beans: 10234, // {Number} 整型
         * }
         */
        refreshBeans: function refreshBeans() {
            var _ref72 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref72$beans = _ref72.beans,
                beans = _ref72$beans === undefined ? 0 : _ref72$beans,
                _ref72$errtip = _ref72.errtip,
                errtip = _ref72$errtip === undefined ? '不支持' : _ref72$errtip,
                _ref72$action = _ref72.action,
                action = _ref72$action === undefined ? 'callapp' : _ref72$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'refreshBeans',
                extend: {
                    beans: parseInt(beans, 10)
                },
                receive: "$['upliveapp_refreshBeans']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'refreshBeans',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /** version: 5.5.7
         * 更新背包
         * @param cfg {
         *      type: {Number} 整型  0:无 1:道具 2:礼物 3:头像框 4:座驾
         * }
         */
        refreshPack: function refreshPack() {
            var _ref73 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref73$type = _ref73.type,
                type = _ref73$type === undefined ? 0 : _ref73$type,
                _ref73$errtip = _ref73.errtip,
                errtip = _ref73$errtip === undefined ? '不支持' : _ref73$errtip,
                _ref73$action = _ref73.action,
                action = _ref73$action === undefined ? 'callapp' : _ref73$action;

            var url = 'uplive://refreshPack?json=';
            var params = {
                key: 'refreshPack',
                extend: {
                    type: type
                },
                receive: "$['upliveapp_refreshPack']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'refreshPack',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /** version: 5.8.0
         * 跳转活跃度奖励-展开功能
         * @param cfg
         * @param data
         */
        getActivityRewardConfig: function getActivityRewardConfig(_ref74) {
            var _ref74$data = _ref74.data,
                data = _ref74$data === undefined ? {} : _ref74$data,
                jsCallback = _ref74.jsCallback;

            var url = 'uplive://activityRewardConfig?json=';
            var params = {
                data: data,
                receive: "$['upliveapp_activityRewardConfig']",
                jsCallback: '$.getActivityRewardConfigComplete'
            };

            $.getActivityRewardConfigComplete = function (param) {
                var _result = {};
                try {
                    _result = JSON.parse(param);
                } catch (error) {}
                jsCallback.call(self, _result);
            };

            url += JSON.stringify(params);
            this.send(url);
        },

        /** version: 5.8.0
         * 领取奖励弹窗
         * @param cfg
         * @params {
         *     level: 等级，exp：u豆经验， goodsName： 免费道具名称， goodsUrl： 图片url， receiveGoods： 0未领取 1已领取
         * }
         */
        getActivityReward: function getActivityReward(_ref75) {
            var _ref75$jsCallback = _ref75.jsCallback,
                jsCallback = _ref75$jsCallback === undefined ? function (param) {} : _ref75$jsCallback,
                _ref75$data = _ref75.data,
                data = _ref75$data === undefined ? {} : _ref75$data;

            var url = 'uplive://activityRewardGet?json=';
            var params = {
                jsCallback: "$.ActivityRewardJsComplete",
                key: 'getActivityReward',
                data: data,
                receive: "$['upliveapp_activityRewardGet']"
            };
            $.ActivityRewardJsComplete = function (param) {
                var _result = {};
                try {
                    _result = JSON.parse(param);
                } catch (error) {}
                jsCallback.call(self, _result);
            };
            url += JSON.stringify(params);
            this.send(url);
        },

        /** version: 5.8.0
         * 购买礼包弹窗 - 特权礼包
         * @param cfg
         * @params {
         *     level: 等级，privilegeGoodsOriDiamond：原始价格，privilegeGoodsDiamond：折后u钻， privilegeGoodsBean：折后u豆
         *      discount： 打折比例，privilegeConfig： 商品信息， receivePrivilege： 0未领取 1已领取
         * }
         */
        getActivityGoodsGet: function getActivityGoodsGet(_ref76) {
            var _ref76$jsCallback = _ref76.jsCallback,
                jsCallback = _ref76$jsCallback === undefined ? function (param) {} : _ref76$jsCallback,
                _ref76$data = _ref76.data,
                data = _ref76$data === undefined ? {} : _ref76$data;

            var url = 'uplive://activityGoodsGet?json=';
            var params = {
                key: 'activityGoodsGet',
                jsCallback: "$.activityGoodsGetJsComplete",
                data: data,
                receive: "$['upliveapp_activityGoodsGet']"
            };
            $.activityGoodsGetJsComplete = function (param) {
                var _result = {};
                try {
                    _result = JSON.parse(param);
                } catch (error) {}
                jsCallback.call(self, _result);
            };
            url += JSON.stringify(params);
            this.send(url);
        },

        /**
         * version: 5.9.0
         * 打开实名认证
         */
        goAuthentication: function goAuthentication() {
            var _ref77 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref77$errtip = _ref77.errtip,
                errtip = _ref77$errtip === undefined ? '' : _ref77$errtip,
                _ref77$action = _ref77.action,
                action = _ref77$action === undefined ? 'callapp' : _ref77$action;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'authentication',
                receive: "$['upliveapp_goAuthentication']"
            };

            url += JSON.stringify(params);

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'goAuthentication',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /* 
         *  更新U钻余额
         *  diamond 剩余U钻
        */
        updateDiamond: function updateDiamond() {
            var _ref78 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref78$diamond = _ref78.diamond,
                diamond = _ref78$diamond === undefined ? '' : _ref78$diamond,
                _ref78$errtip = _ref78.errtip,
                errtip = _ref78$errtip === undefined ? '' : _ref78$errtip,
                _ref78$action = _ref78.action,
                action = _ref78$action === undefined ? 'callapp' : _ref78$action,
                _ref78$complete = _ref78.complete,
                complete = _ref78$complete === undefined ? function () {} : _ref78$complete;

            var url = 'uplive://updateDiamond?json=';
            var _self = this;
            var params = {
                diamond: diamond,
                receive: 'updateDiamondReceive',
                jsCallback: '$.updateDiamondComplete'
            };

            url += JSON.stringify(params);

            $.updateDiamondComplete = function (res) {
                var _result = {};

                try {
                    _result = JSON.parse(res);
                } catch (error) {}

                complete.call(_self, _result);
            };

            if (action == 'callapp') {
                this.send(url);
                this.checkAvail({
                    apiname: 'updateDiamond',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },


        /* -------------------------------   6.4.0新增   --------------------------------- */
        /* 
         *  跳转到修改UP号页面
         *  
        */
        goUpcodeRename: function goUpcodeRename() {
            var _ref79 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref79$errtip = _ref79.errtip,
                errtip = _ref79$errtip === undefined ? '' : _ref79$errtip;

            var url = 'uplive://goWindow?json=';
            var params = {
                key: 'upcodeRename',
                receive: "$[upliveapp_goUpcodeRename]",
                jsCallback: "$.goUpcodeRenameComplete"
            };

            url += JSON.stringify(params);

            this.send(url);
            this.checkAvail({
                apiname: 'upcodeRename',
                errtip: errtip
            });
        },

        /**
         * 用户弹窗详情协议(直播间可用) 6.8.0
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        showChatroomUserProfile: function showChatroomUserProfile() {
            var _ref80 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref80$uid = _ref80.uid,
                uid = _ref80$uid === undefined ? 10005 : _ref80$uid,
                _ref80$errtip = _ref80.errtip,
                errtip = _ref80$errtip === undefined ? '' : _ref80$errtip,
                _ref80$action = _ref80.action,
                action = _ref80$action === undefined ? 'showProfile' : _ref80$action;

            var url = 'uplive://showChatroomUserProfile?json=';
            var params = {
                key: 'showChatroomUserProfile',
                uid: +uid,
                receive: "$['upliveapp_showChatroomUserProfile']"
            };

            url += JSON.stringify(params);

            if (action == 'showProfile') {
                this.send(url);
                this.checkAvail({
                    apiname: 'showChatroomUserProfile',
                    errtip: errtip
                });
            } else {
                return this.checkUrl(url);
            }
        },

        /**
         * 半屏充值协议 6.9.0
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        showRecharge: function showRecharge() {
            var _ref81 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref81$price = _ref81.price,
                price = _ref81$price === undefined ? 0 : _ref81$price,
                _ref81$fromPage = _ref81.fromPage,
                fromPage = _ref81$fromPage === undefined ? 0 : _ref81$fromPage,
                _ref81$isMoneyNotEnou = _ref81.isMoneyNotEnough,
                isMoneyNotEnough = _ref81$isMoneyNotEnou === undefined ? 1 : _ref81$isMoneyNotEnou,
                _ref81$errtip = _ref81.errtip,
                errtip = _ref81$errtip === undefined ? '' : _ref81$errtip;

            var url = 'uplive://showRecharge?json=';
            var params = {
                key: 'showRecharge',
                price: +price,
                fromPage: fromPage,
                isMoneyNotEnough: isMoneyNotEnough,
                receive: "$['upliveapp_showRecharge']"
            };
            url += JSON.stringify(params);
            this.send(url);
            this.checkAvail({
                apiname: 'showRecharge',
                errtip: errtip
            });
        },


        /**
         * 获取吸顶状态, 及安全区边界
         * @param cfg {
         *      invalid 0: usertoken失效，重新获取；1：第一次获取
         *      complete: function(){}
         * }
         *
         */
        getSafeAreaInsets: function getSafeAreaInsets() {
            var _ref82 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                _ref82$complete = _ref82.complete,
                complete = _ref82$complete === undefined ? function () {} : _ref82$complete,
                _ref82$invalid = _ref82.invalid,
                invalid = _ref82$invalid === undefined ? 0 : _ref82$invalid,
                _ref82$errtip = _ref82.errtip,
                errtip = _ref82$errtip === undefined ? '不支持' : _ref82$errtip;

            var self = this;
            var url = 'uplive://getSafeAreaInsets?json=';
            var params = {
                invalid: invalid,
                receive: "$['upliveapp_getSafeAreaInsets']",
                jsCallback: '$.getSafeAreaInsetsComplete'
            };

            $.getSafeAreaInsetsComplete = function (param) {
                // usertoken: "", uid: "", language: ""
                complete.call(self, JSON.parse(param));
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'getSafeAreaInsets',
                errtip: errtip
            });
        },

        // 三方游戏邀请好友
        inviteFriendsPlayGame: function inviteFriendsPlayGame(cfg) {
            var _ref83 = cfg || {},
                _ref83$success = _ref83.success,
                success = _ref83$success === undefined ? 1 : _ref83$success,
                errtip = _ref83.errtip,
                direction = _ref83.direction,
                gameId = _ref83.gameId,
                gameIcon = _ref83.gameIcon,
                inviteGameUrl = _ref83.inviteGameUrl,
                titleList = _ref83.titleList,
                contentList = _ref83.contentList,
                highlightContentList = _ref83.highlightContentList,
                jsCallback = _ref83.jsCallback;

            var url = 'uplive://inviteFriendsPlayGame?json=';
            var params = {
                success: success,
                receive: "$['upliveapp_inviteFriendsPlayGame']",
                // 0：底部，1：左侧底部（镜像） 2: 右侧底部（镜像）
                direction: direction,
                // 游戏标识，客户端会用次字段做1小时分享一次的限制 ，限制维度是（相同的游戏对相同的人做1小时限制）
                gameId: gameId,
                // "游戏图标地址"
                gameIcon: gameIcon,
                inviteGameUrl: inviteGameUrl,
                // 邀请标题  {"en-US":"邀请标题",....}
                titleList: titleList,
                // {"en-US":"描述介绍",....}
                contentList: contentList,
                // {"en-US":"高亮内容部分",....}
                highlightContentList: highlightContentList,
                // 协议回调方法
                jsCallback: '$.inviteFriendsPlayGameComplete'
            };

            $.inviteFriendsPlayGameComplete = function () {
                jsCallback && jsCallback.apply(undefined, arguments);
            };

            this.send(url + JSON.stringify(params));
            this.checkAvail({
                apiname: 'inviteFriendsPlayGame',
                errtip: errtip
            });
        }
    };

    var _loop = function _loop(i) {
        $['upliveapp_' + i] = function () {
            apiStatus[i] = 1;
        };
    };

    for (var i in native) {
        _loop(i);
    }

    window.UpSDK = native;

    if (typeof module != 'undefined' && module.exports) {
        module.exports = native;
    } else {
        window.UpSDK = native;
    }

    if (window.define && define.cmd) {
        define(function (require, exports, module) {
            module.exports = native;
        });
    }
})(window, window.Zepto || window.jQuery || (window['$'] = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-native/dist/index.js
// module id = 130
// module chunks = 0